<template>
  <div class="home">
    <template v-if="showSeniors">
      <HomeSA :config="config" />
    </template>

    <template v-else-if="showAus === 'Y' || showWpg === 'Y'">
      <HomeAW :config="config" />
    </template>

    <template v-else>
      <HomeSA :config="config" />
    </template>
     <!-- <HomeAW :config="config" /> -->
  </div>
</template>

<script>
import HomeAW from "@/components/StarterHome.vue";
import HomeSA from "@/components/SecondHome.vue";
import axios from "axios";
export default {
  name: "Firsthome", 
  props:["config"],
  components: { 
    HomeAW,
    HomeSA
  },
  data: function() {
    return {
     showAus: 'N',
     showWpg: 'N',
     showSnr: 'N',
     showAll: 'N',
     showSeniors: false
    };
  },
  mounted() {
    const url = `https://api.aus.ocs-software.com/pgaaus/cache/aus/tmticx?multi=Y&tour=aus&tour=wpg&tour=snr&maxdays=10&days=-5&randomadd=${Date.now()}`;

    axios.get(url)
      .then(({ data }) => {
        const getTournament = tour => data?.[tour]?.[0]?.[0]?.data;

        const ausTournament = getTournament('aus');
        const wpgTournament = getTournament('wpg');
        const seniorsTournament = getTournament('snr');

        const isRunning = tournament =>
          tournament &&
          Number(tournament.days_away) <= 0 &&
          tournament.ts_final_result !== 'Y';

        const ausRunning = isRunning(ausTournament);
        const wpgRunning = isRunning(wpgTournament);
        const seniorsRunning = isRunning(seniorsTournament);

        this.showAus = ausTournament ? 'Y' : 'N';
        this.showWpg = wpgTournament ? 'Y' : 'N';
        this.showSnr = seniorsTournament ? 'Y' : 'N';

        this.showSeniors =
          seniorsRunning && !ausRunning && !wpgRunning;
      })
      .catch(error => {
        console.error('API error:', error);
      });
  }
};
</script>
